export default __webpack_public_path__ + "static/media/65.0e030781.png";